import cabecalho from '@/components/global/Cabecalho/Cabecalho.vue'
import menuLateral from '@/components/global/MenuLateral/MenuLateral.vue'
import pagination from '@/components/layout/pagination/Pagination.vue'
import defaultTable from '@/components/layout/defaultTable/DefaultTable.vue'
import { BSpinner, BToast } from 'bootstrap-vue'
import mensagens from '@/util/mensagens'
import util from '@/util'
import { mapState } from 'vuex'
import constants from '@/util/constants'

export default {
  name: 'convites',
  components: {
    cabecalho,
    menuLateral,
    pagination,
    'default-table': defaultTable,
    'b-spinner': BSpinner,
    'b-toast': BToast
  },

  computed: {
    ...mapState('pagination', ['registrosPorPagina']),
    desabilitarBotaoSalvar () {
      const convitesSelecionadoVazios = util.valorVazio(this.filtrarConvitesSelecionados(this.listaDeConvitesSelecionados))
      const notificacoesSelecionadoVazios = util.valorVazio(this.filtrarConvitesSelecionados(this.listaDeNotificacoesSelecionados))
      return convitesSelecionadoVazios && notificacoesSelecionadoVazios
    }
  },

  data: () => {
    return {
      flagsDeControle: {
        carregandoDados: {
          status: false,
          mensagem: ''
        },
        manipulandoDados: {
          status: false,
          mensagem: ''
        }
      },
      componentePaginacao: {
        pagina: 1,
        registrosPorPagina: null,
        fonteDeDados: [],
        ultimaPagina: 1
      },
      statusConvites: constants.statusConvites,
      componenteOrdenacao: {
        campo: 'f_dtstart',
        sentido: 'asc'
      },
      dadosRetorno: {
        sucesso: false,
        mensagem: '',
        listaDeErros: []
      },
      listaDeConvitesSelecionados: [],
      listaDeNotificacoesSelecionados: [],
      listaDeConvites: [],
      fields: [
        { key: 'f_summary', sortable: true, label: 'Evento' },
        { key: 'f_dtstart', sortable: true, label: 'Inicio' },
        { key: 'f_dtend', sortable: true, label: 'Termino' },
        { key: 'f_status', sortable: false, label: 'Situação' },
        { key: 'options', label: 'Opções' }
      ]
    }
  },

  mounted () {
    this.componentePaginacao.registrosPorPagina = this.registrosPorPagina
    this.obterListaConvites()
  },

  methods: {
    tabelaSemRegistros (item, type) {
      if (util.valorVazio(item) && type === 'row-empty') {
        return 'text-center'
      }
    },
    adicionarCampoSituacaoNaListaConvites (dadosRetornados) {
      return dadosRetornados.map(convite => ({ ...convite, situacao: null }))
    },
    async obterListaConvites () {
      this.definirFlagCarregandoDados(true, mensagens.carregandoDadosEdicao)
      try {
        this.resetarListaDeConvitesSelecionados()

        let parametrosRequisicao = {
          'page': this.componentePaginacao.pagina,
          'registrosPorPagina': this.componentePaginacao.registrosPorPagina,
          'ordenacao': this.componenteOrdenacao
        }
        const resposta = await this.axios.post('/agenda/convites-notificacoes-pendentes', parametrosRequisicao)

        this.listaDeConvites = this.adicionarCampoSituacaoNaListaConvites(resposta.data.retorno.dados)
        this.componentePaginacao.fonteDeDados = resposta.data.retorno.paginacao
        this.componentePaginacao.ultimaPagina = resposta.data.retorno.ultimaPagina
      } catch (e) {
        util.criarAlertaToastDeErro(this, 'Aviso', mensagens.falhaServidorCarregandoDados)
      }
      this.definirFlagCarregandoDados(false, '')
    },

    ordenarLista (context) {
      if (!util.valorVazio(context.sortBy)) {
        this.componenteOrdenacao.campo = context.sortBy
        this.componenteOrdenacao.sentido = context.sortDesc === true ? 'desc' : 'asc'
        this.obterListaConvites()
      }
    },

    async obterDadosPaginados (pagina, registrosPorPagina) {
      this.componentePaginacao.pagina = pagina
      this.componentePaginacao.registrosPorPagina = registrosPorPagina
      this.obterListaConvites()
    },

    adicionarItemSelecionado (itemSelecionado) {
      if (this.ehNotificao(itemSelecionado)) {
        this.adicionarNotificacaoSelecionada(itemSelecionado)
        return
      }
      this.adicionarConviteSelecionado(itemSelecionado)
    },

    adicionarNotificacaoSelecionada (notificacaoSelecionada) {
      const pesquisaNotificacaoSelecionada = this.pesquisaNotificacaoSelecionada(notificacaoSelecionada)
      const notificacaoExistente = this.listaDeNotificacoesSelecionados.some(pesquisaNotificacaoSelecionada)

      if (!notificacaoExistente) {
        const novaNotificacao = { f_id: notificacaoSelecionada.f_id, f_event: notificacaoSelecionada.f_event }
        this.listaDeNotificacoesSelecionados = [...this.listaDeNotificacoesSelecionados, novaNotificacao]
        return
      }
      this.listaDeNotificacoesSelecionados = this.removerNotificacaoSelecionada(notificacaoSelecionada)
    },

    removerNotificacaoSelecionada (notificacaoSelecionada) {
      return this.listaDeNotificacoesSelecionados.filter(notificacao => notificacao.f_id !== notificacaoSelecionada.f_id)
    },

    adicionarConviteSelecionado (conviteSelecionado) {
      const pesquisaConviteSelecionado = this.pesquisaConviteSelecionado(conviteSelecionado)
      const conviteJaExiste = this.listaDeConvitesSelecionados.some(pesquisaConviteSelecionado)
      if (!conviteJaExiste) {
        const novoConvite = { f_id: conviteSelecionado.f_id, f_status: conviteSelecionado.situacao, f_event: conviteSelecionado.f_event }
        this.listaDeConvitesSelecionados = [...this.listaDeConvitesSelecionados, novoConvite]

        return
      }
      const convite = this.listaDeConvitesSelecionados.find(pesquisaConviteSelecionado)
      const mudouStatus = (convite.situacao !== conviteSelecionado.f_status)

      if (mudouStatus) {
        this.atualizarStatusConviteSelecionado(conviteSelecionado)
      }
    },

    atualizarStatusConviteSelecionado (conviteSelecionado) {
      const listaConviteSelecionadosAtualizada = this.listaDeConvitesSelecionados.map(convite => {
        if (convite.f_id === conviteSelecionado.f_id) {
          return { ...convite, f_status: conviteSelecionado.situacao }
        }
        return convite
      })
      this.listaDeConvitesSelecionados = listaConviteSelecionadosAtualizada
    },

    pesquisaConviteSelecionado (conviteSelecionado) {
      return convite => (convite.f_id === conviteSelecionado.f_id)
    },

    pesquisaNotificacaoSelecionada (notificacaoSelecionada) {
      return notificacao => (notificacao.f_id === notificacaoSelecionada.f_id)
    },

    filtrarConvitesSelecionados (convites) {
      const convitesSelecionados = convites
        .filter(this.filtroRemoverConvitesPendentes)
      return convitesSelecionados
    },

    async salvarEmLote () {
      this.definirFlagManipulandoDados(true, mensagens.salvandoDadosCadastro)
      try {
        const convitesSelecionados = this.filtrarConvitesSelecionados(this.listaDeConvitesSelecionados)
        const notificacoesSelecionadas = this.filtrarConvitesSelecionados(this.listaDeNotificacoesSelecionados)
        let parametrosRequisicaoConvites = {
          convites: convitesSelecionados,
          notificacoes: notificacoesSelecionadas
        }

        const resposta = await this.axios.put('/agenda/alterar-status-convite', parametrosRequisicaoConvites)

        this.dadosRetorno.sucesso = resposta.data.retorno.sucesso
        this.dadosRetorno.mensagem = resposta.data.retorno.mensagem
        this.dadosRetorno.listaDeErros = resposta.data.retorno.listaDeErros
        this.tratarAposSalvarRegistro()
      } catch (e) {
        util.criarAlertaToastDeErro(this, 'Aviso', mensagens.falhaServidorSalvandoDados)
      }
      this.definirFlagManipulandoDados(false, '')
    },

    tratarAposSalvarRegistro () {
      if (this.dadosRetorno.sucesso) {
        util.criarAlertaToastDeSucesso(this, 'Aviso', 'Dados salvos com sucesso.')
      } else {
        util.criarAlertaToastDeErro(this, 'Aviso', this.dadosRetorno.mensagem)
        this.tratarListaDeErros(this.dadosRetorno.listaDeErros)
      }
      this.componentePaginacao.pagina = 1
      this.obterListaConvites()
    },

    resetarListaDeConvitesSelecionados () {
      this.listaDeConvitesSelecionados = []
      this.listaDeNotificacoesSelecionados = []
    },

    definirFlagCarregandoDados (status, mensagem) {
      this.flagsDeControle.carregandoDados.status = status
      this.flagsDeControle.carregandoDados.mensagem = mensagem
    },

    definirFlagManipulandoDados (status, mensagem) {
      this.flagsDeControle.manipulandoDados.status = status
      this.flagsDeControle.manipulandoDados.mensagem = mensagem
    },

    tratarListaDeErros (erros) {
      const listaDeErros = Object.entries(erros)
      for (const [campo, erro] of listaDeErros) {
        const traducaoCampo = this.obterTraducaoCampo(campo)
        const mensagem = `${traducaoCampo}: ${erro}`
        util.criarAlertaToastDeErro(this, 'Aviso', mensagem)
      }
    },

    obterTraducaoCampo (campo, erro) {
      const traducoes = {
        'convites.*.f_status': 'Status',
        'notificacoes.*.f_id': 'Notificação',
        'notificacoes.*.f_type': 'Status',
        'convites.*.f_id': 'Convite',
        'convites.*.f_user': 'Participante',
        'convites.*.f_event': 'Evento'
      }

      return traducoes[campo] ?? ''
    },

    filtroRemoverConvitesPendentes (convite) {
      return convite.f_status !== null
    },

    ehConvitePendente (convite) {
      if (util.valorEhNulo(convite.f_status)) {
        return false
      }
      const listaDePossiveisConvites = [ constants.statusConvites.aceito, constants.statusConvites.rejeitado, constants.statusConvites.pendente ]

      return listaDePossiveisConvites.includes(convite.f_status)
    },

    ehNotificacaoPendente (convite) {
      if (util.valorEhNulo(convite.f_type)) {
        return false
      }
      const listaDePossiveisNotificacaoConvites = [ constants.statusConvites.notificacaoConviteAceito, constants.statusConvites.notificacaoConviteNegado ]

      return listaDePossiveisNotificacaoConvites.includes(convite.f_type)
    },

    ehNotificacaoCancelada (convite) {
      if (util.valorEhNulo(convite.f_status)) {
        return false
      }
      const listaDePossiveisNotificacaoConvites = [ constants.statusConvites.notificacaoCancelamento ]

      return listaDePossiveisNotificacaoConvites.includes(convite.f_status)
    },

    voltarCalendario () {
      this.$router.push({ name: 'agenda' })
    },

    formatarDataHora (data) {
      const dataFormatada = util.formatarData(data, 'DD/MM/YYYY HH:mm')
      return dataFormatada
    },

    ehNotificao (convite) {
      return !util.valorEhNulo(convite.f_type)
    },

    traduzirStatusConvite (convite) {
      if (this.ehNotificacaoPendente(convite)) {
        return this.obterMensagemNotificacao(convite.f_type)
      }
      return this.obterMensagemConvite(convite.f_status)
    },
    obterMensagemConvite (statusConvite) {
      switch (statusConvite) {
        case 1:
          return constants.statusConvites.pendenteLabel
        case 2:
          return constants.statusConvites.aceitoLabel
        case 3:
          return constants.statusConvites.rejeitadoLabel
        case 4:
          return constants.statusConvites.notificacaoCancelamentoLabel
      }
    },
    obterMensagemNotificacao (tipoNotificacao) {
      switch (tipoNotificacao) {
        case 1:
          return constants.statusConvites.notificacaoConviteAceitoLabel
        case 2:
          return constants.statusConvites.notificaoConviteNegadoLabel
      }
    }
  }
}
